import { put, call, select, takeLatest } from 'redux-saga/effects';

import { notification } from 'antd';
import FileSaver from 'file-saver';
import moment from 'moment';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';

import InvoicePicklistReportActions, {
  InvoicePicklistReportTypes
} from '../Stores/InvoicePicklistReport/Actions';

const getAppStore = state => state.app;

export function* invoicePicklistReportFetch({
  criteria,
  sorts = [],
  pageSize = 20,
  page = 1,
  formikBag
}) {
  try {
    if (formikBag) {
      formikBag.setSubmitting(true);
    }

    yield put(InvoicePicklistReportActions.invoicePicklistReportLoading(true));

    const app = yield select(getAppStore);

    const postData = {
      sorts,
      filters: {
        doc_code: criteria.doc_code || '',
        doc_date: criteria.doc_date || null
      },
      pageSize,
      page
    };

    const result = yield call(
      ApiService.postApi,
      app.apiUrl,
      'report/invoice/picklist',
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const paginator = result.data;

      yield put(
        InvoicePicklistReportActions.invoicePicklistReportFetchSuccess(
          criteria,
          sorts,
          paginator.data || [],
          {
            current: paginator.current_page || page,
            pageSize: paginator.per_page || pageSize,
            total: paginator.total || 0
          }
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    if (formikBag) {
      formikBag.setSubmitting(false);
    }

    yield put(InvoicePicklistReportActions.invoicePicklistReportLoading(false));
  }
}

export function* invoicePicklistReportExport({ criteria }) {
  try {
    yield put(InvoicePicklistReportActions.invoicePicklistReportExportLoading(true));

    const app = yield select(getAppStore);

    const postData = {
      filters: {
        doc_code: criteria.doc_code || '',
        doc_date: criteria.doc_date || null
      }
    };

    const result = yield call(
      ApiService.downloadPostApi,
      app.apiUrl,
      'report/invoice/picklist/export',
      app.token,
      postData,
      {},
      'application/json'
    );

    if (result.isSuccess === true) {
      const fileNameParts = ['Invoice_Picklist'];

      if (criteria.doc_code) {
        fileNameParts.push(criteria.doc_code.replace(/[^A-Za-z0-9_-]/g, '_'));
      }

      if (criteria.doc_date) {
        fileNameParts.push(moment(criteria.doc_date).format('YYYYMMDD'));
      }

      fileNameParts.push(moment().format('YYYYMMDD_HHmmss'));

      FileSaver.saveAs(result.data, `${fileNameParts.join('_')}.xlsx`);
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvoicePicklistReportActions.invoicePicklistReportExportLoading(false));
  }
}

export const saga = [
  takeLatest(InvoicePicklistReportTypes.INVOICE_PICKLIST_REPORT_FETCH, invoicePicklistReportFetch),
  takeLatest(InvoicePicklistReportTypes.INVOICE_PICKLIST_REPORT_EXPORT, invoicePicklistReportExport)
];
